import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import CrudList from "@/components/CrudList";

export default function KasBank() {
  const [sites, setSites] = useState([]);
  useEffect(() => { api.get("/sites").then((r) => setSites(r.data)); }, []);
  return (
    <CrudList
      title="Kas / Bank"
      subtitle="Rekap keluar-masuk dana per kategori"
      endpoint="/kas-bank"
      exportModule="kas-bank"
      columns={[
        { key: "date", label: "Tanggal" },
        { key: "type", label: "Tipe" },
        { key: "account", label: "Akun" },
        { key: "amount", label: "Jumlah", render: (r) => <span className={r.type === "masuk" ? "text-[#16A34A]" : "text-[#DC2626]"}>{r.type === "masuk" ? "+" : "-"} Rp {(r.amount || 0).toLocaleString('id-ID')}</span> },
        { key: "category", label: "Kategori" },
        { key: "description", label: "Deskripsi" },
        { key: "site_id", label: "Site", render: (r) => sites.find((s) => s.id === r.site_id)?.name || "-" },
      ]}
      fields={[
        { key: "date", label: "Tanggal", type: "date", required: true },
        { key: "type", label: "Tipe", type: "select", options: [
          { value: "masuk", label: "Masuk" },
          { value: "keluar", label: "Keluar" },
        ], required: true },
        { key: "account", label: "Akun", type: "select", options: [
          { value: "kas", label: "Kas" },
          { value: "bank", label: "Bank" },
        ], required: true },
        { key: "amount", label: "Jumlah (Rp)", type: "number", required: true },
        { key: "category", label: "Kategori", placeholder: "BBM / Gaji / Sparepart / Sales", required: true },
        { key: "site_id", label: "Site", type: "select", options: sites.map((s) => ({ value: s.id, label: s.name })) },
        { key: "description", label: "Deskripsi", wide: true },
        { key: "photo_url", label: "Foto Nota / Bukti Transfer", type: "photo", kind: "kas-bank", wide: true },
      ]}
    />
  );
}
